// Bound both response headers and body. Aborting alone does not settle every transport.
export function withAssistantDeadline(work, controller, timeoutMs = 10000) {
  let timer, abort;
  const cancellation = new Promise((_, reject) => {
    abort = () => reject(new Error('Assistant request cancelled'));
    controller.signal.addEventListener('abort', abort, { once: true });
    if (controller.signal.aborted) abort();
    timer = setTimeout(() => {
      reject(new Error('Assistant request timed out'));
      controller.abort();
    }, timeoutMs);
  });
  return Promise.race([Promise.resolve().then(work), cancellation]).finally(() => {
    clearTimeout(timer);
    controller.signal.removeEventListener('abort', abort);
  });
}
